import React from 'react';
import { DateRangeDropdownV2 } from '@/components/custom/erp';
import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

const BasicInfo: React.FC = () => {
  return (
    <div className='space-y-2 p-4'>
      <div className='flex flex-col space-y-3'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Ngày c/từ(từ/đến)</Label>
          <div>
            <DateRangeDropdownV2 fromDateName='ngay_ct1' toDateName='ngay_ct2' />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Số c/từ(từ/đến)</Label>
          <div className='flex gap-2'>
            <FormField name='so_ct1' type='text' />
            <FormField name='so_ct2' type='text' />
          </div>
        </div>

        <div className='flex w-full items-center'>
          <Label className='w-40 min-w-40'>Diễn giải</Label>
          <FormField name='dien_giai' type='text' className='w-full' />
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
